import { Component, ContentChild, Input } from '@angular/core';
import { ImageCardButtonComponent } from './components/button/button.component';
import { ImageCardDescriptionComponent } from './components/description/description.component';
import { GpuLayoutModule } from '@geneplanet/ngx-ui/src/lib/layout';

@Component({
  selector: 'app-image-card',
  templateUrl: './image-card.component.html',
  styleUrls: ['./image-card.component.scss'],
  imports: [GpuLayoutModule],
  standalone: true,
})
export class ImageCardComponent {
  @Input() imgS: string;
  @Input() imgL: string;
  @ContentChild(ImageCardDescriptionComponent)
  description: ImageCardDescriptionComponent;
  @ContentChild(ImageCardButtonComponent)
  button: ImageCardButtonComponent;

  linearGradient =
    'linear-gradient(180deg, rgba(58, 67, 113, 0) 0.03%, rgba(58, 67, 113, 0.75) 100%)';
}
